import React, { useState, ReactNode } from 'react';
import { Formik, useField } from 'formik';
import { InputProps as MuiInputProps } from '@material-ui/core/Input';
import { InputLabelProps as MuiInputLabelProps } from '@material-ui/core/InputLabel';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';

import { IconName } from '../../icons';
import { default as Input, InputClassKey } from './input';

type FormikInputProps = {
  name: string;
  errorMessage?: string;
  iconName: IconName;
  labelText: string;
  InputProps?: MuiInputProps;
  InputLabelProps?: MuiInputLabelProps;
  classes?: Partial<ClassNameMap<InputClassKey>>;
};

const FormikInput = (props: FormikInputProps): React.ReactElement => {
  const [field, meta] = useField(props.name);

  let hasValue = !!field.value;
  if (props.InputProps && props.InputProps.type === 'number') {
    hasValue = field.value !== 'NaN';
  }

  const [shrink, setShrink] = useState(hasValue);
  const shrinkLabel = (): void => {
    setShrink(true);
  };
  const unShrinkLabel = (event: React.FocusEvent<HTMLInputElement>): void => {
    if (event.target.value.length === 0) {
      setShrink(false);
    }
  };
  const onFocusEventHandler = (event: React.FocusEvent<HTMLInputElement>): void => {
    shrinkLabel();
  };
  const onBlurEventHandler = (event: React.FocusEvent<HTMLInputElement>): void => {
    unShrinkLabel(event);
    field.onBlur(event);
  };

  return (
    <Input
      iconName={props.iconName}
      labelText={props.labelText}
      helperText={meta.touched ? meta.error : ''}
      error={Boolean(meta.touched) && (Boolean(meta.error) || Boolean(props.errorMessage))}
      classes={{ ...props.classes }}
      InputLabelProps={{
        ...props.InputLabelProps,
        shrink: shrink
      }}
      InputProps={{
        name: props.name,
        onChange: field.onChange,
        onFocus: onFocusEventHandler,
        onBlur: onBlurEventHandler,
        value: field.value,
        ...props.InputProps
      }}
    />
  );
};

export default FormikInput;
